import { mapState } from 'vuex';
export default {
  name: 'MonitoringEnableDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState('app', ['color']),
    hasExistingConfig() {
      var _this$config$properti;
      return this.config && ((_this$config$properti = this.config.properties) === null || _this$config$properti === void 0 || (_this$config$properti = _this$config$properti.metadata) === null || _this$config$properti === void 0 ? void 0 : _this$config$properti.lastDeactivatedAt);
    },
    lastDeactivatedDate() {
      if (!this.hasExistingConfig) {
        return '';
      }
      const date = new Date(this.config.properties.metadata.lastDeactivatedAt);
      return date.toLocaleString();
    },
    promptButtons() {
      const buttons = [{
        text: this.$i18n_t('Connectors.Monitoring.dialogs.enable.cancel'),
        emit: 'cancel'
      }];
      if (this.hasExistingConfig) {
        buttons.push({
          text: this.$i18n_t('Connectors.Monitoring.dialogs.enable.useOld'),
          color: this.color,
          emit: 'use-old'
        }, {
          text: this.$i18n_t('Connectors.Monitoring.dialogs.enable.createNew'),
          color: this.color,
          emit: 'create-new'
        });
      } else {
        buttons.push({
          text: this.$i18n_t('Connectors.Monitoring.dialogs.enable.create'),
          color: this.color,
          emit: 'create-new'
        });
      }
      return buttons;
    }
  }
};